import { UrlConstants } from "../url.constants";
export class ApiAttachmentUploadSessionConstants {
    static URL = UrlConstants.API_V2 + "AttachmentUploadSession";
    static FUNCTION_START_UPLOAD = "StartUpload";
    static FUNCTION_UPLOAD_CHUNK = "UploadChunk";
    static FUNCTION_GET_UPLOADED_CHUNKS = "GetUploadedChunks";
    static FUNCTION_MERGE_CHUNKS = "MergeChunks";
}
